import * as React from "react";
import {
  Box,
  Typography,
  Stack,
  Paper,
} from "@mui/material";
import { useI18n } from "../../i18n/I18nProvider";
import { useWorkshopBlocker, FLOW } from "../../logic/useWorkshopBlocker";


export default function BlackOutIntro(props: { handlePageChange: (page: string) => void }) {
  const { handlePageChange } = props;
  const blocker = useWorkshopBlocker();

  const { lang } = useI18n();
  const isDE = lang === "de";

  React.useEffect(() => {
    const myIndex = FLOW.indexOf("BlackOutIntro");
    const blockerIndex = FLOW.indexOf(blocker);
    if (blockerIndex > myIndex + 1) {
      handlePageChange(FLOW[myIndex + 1]);
    }
  }, [blocker, handlePageChange]);

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 48px)",
        width: "100%",
        px: { xs: 2, sm: 3 },
        py: { xs: 3, sm: 6 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `
          radial-gradient(circle at 20% 20%, rgba(251, 2, 2, 0.08), transparent 40%),
          radial-gradient(circle at 80% 30%, rgba(255, 0, 0, 0.06), transparent 40%),
          #111010
        `,
        backgroundImage: `
          linear-gradient(
            rgba(8, 8, 8, 0.78),
            rgba(8, 8, 8, 0.82)
          ),
          url("/scenarioBgs/threats.png")
        `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <Paper
        sx={{
          width: { xs: "100%", sm: "min(88vw, 780px)", md: "min(78vw, 860px)" },
          borderRadius: 5,
          p: { xs: 4, sm: 6, md: 7 },
          border: "1px solid rgba(255,255,255,0.14)",
          background:
            "linear-gradient(180deg, rgba(49, 32, 32, 0.95), rgba(34, 21, 21, 0.94))",
          boxShadow: "0 24px 65px rgba(0,0,0,0.45)",
          textAlign: "center",
        }}
      >
        <Stack spacing={4} alignItems="center">
          <Typography
            sx={{
              color: "#fff",
              fontSize: { xs: "1.6rem", sm: "2rem", md: "2.3rem" },
              fontWeight: 800,
              letterSpacing: "0.08em",
              lineHeight: 1.3,
            }}
          >
            {isDE
              ? "Willkommen zum Workshop! Deine Resilienzreise beginnt jetzt."
              : "Welcome to the workshop! Your resilience journey starts here."
            }
          </Typography>

          <Typography
            sx={{
              color: "rgba(255,255,255,0.8)",
              fontSize: { xs: "1rem", sm: "1.15rem" },
              fontWeight: 400,
              letterSpacing: "0.06em",
            }}
          >
            {isDE ? "Bist du bereit?" : "Are you ready?"}
          </Typography>

          <Typography
            sx={{
              color: "rgba(255,255,255,0.5)",
              fontSize: { xs: "0.9rem", sm: "1rem" },
              maxWidth: 500,
            }}
          >
            {isDE
              ? "In den nächsten Schritten wirst du deine Wahrnehmung, Entscheidungen und Reaktionen neu entdecken."
              : "In the next steps, you will explore your perception, decisions, and reactions in a new way."
            }
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}